import React, {useState} from "react";
import {connect} from 'react-redux';
import GymMarker from "../Markers/Gym/GymMarker";
import {selectVisibleGyms} from "../../store/selectors/gyms";
import {selectVisibleRaids} from "../../store/selectors/raids";
import RaidMarker from "../Markers/Raid/RaidMarker";
import InfoWindow from "../Markers/InfoWindow";
import RaidMarkerPopup from "../Markers/Raid/RaidMarkerPopup";
import GymMarkerPopup from "../Markers/Gym/GymMarkerPopup";
import PokemonMarker from "../Markers/Pokemon/PokemonMarker";
import {selectVisiblePokemon} from "../../store/selectors/pokemon";
import PokemonMarkerPopup from "../Markers/Pokemon/PokemonMarkerPopup";
import {selectVisibleStops} from "../../store/selectors/stops";
import StopMarkerPopup from "../Markers/Stop/StopMarkerPopup";
import StopMarker from "../Markers/Stop/StopMarker";
import Map from "./Map";
import {Page} from "../../store/coreSlice";
import NestMarker from "../Markers/Nest/NestMarker";
import NestMarkerPopup from "../Markers/Nest/NestMarkerPopup";
import DotMarker from "../Markers/Dot/DotMarker";
import Level14CellCenter from "../Markers/Level14CellCenter/Level14CellCenter";
import {selectVisiblePortals} from "../../store/selectors/portals";
import {selectVisiblePendings} from "../../store/selectors/pending";
import DotMarkerPopup from "../Markers/Dot/DotMarkerPopup";
import {S2MarkerType} from "../../utils/s2";

const MapContainer = (props) => {
	const [infoWindowMarker, setInfoWindowMarker] = useState(null);

	const showPopup = (key) => {
		setInfoWindowMarker(key);
	};

	const onClosePopup = () => {
		setInfoWindowMarker(null);
	};

	let markers = [

	];

	if( props.page === Page.LIVE ) {
		markers = markers.concat(
			props.visiblePokemon.map(pokemon => {
				const key = 'pokemon-' + pokemon.encounter_id;
				return <PokemonMarker key={key} lat={pokemon.latitude} lng={pokemon.longitude} pokemon={pokemon}
									  onClick={() => showPopup(key)}
									  infoWindow={infoWindowMarker === key && <InfoWindow onClose={onClosePopup}
																						  text={<PokemonMarkerPopup
																							  id={key}
																							  pokemon={pokemon}/>}/>}/>;
			}),
			props.visibleGyms.map(gym => {
				const key = 'gym-' + gym.gym_id;
				return <GymMarker key={key} lat={gym.latitude} lng={gym.longitude} gym={gym}
								  onClick={() => showPopup(key)}
								  infoWindow={infoWindowMarker === key &&
								  <InfoWindow onClose={onClosePopup} text={<GymMarkerPopup id={key} gym={gym}/>}/>}/>;
			}),
			props.visibleRaids.map(raid => {
				const key = 'raid-' + raid.gym_id + raid.start;
				return <RaidMarker key={key} lat={raid.latitude} lng={raid.longitude} raid={raid}
								   onClick={() => showPopup(key)}
								   infoWindow={infoWindowMarker === key && <InfoWindow onClose={onClosePopup}
																					   text={<RaidMarkerPopup id={key}
																											  raid={raid}/>}/>}/>;
			}),
			props.visibleStops.map(stop => {
				const key = 'stop-' + stop.latitude + stop.longitude;
				return <StopMarker key={key} lat={stop.latitude} lng={stop.longitude} stop={stop}
								   onClick={() => showPopup(key)}
								   infoWindow={infoWindowMarker === key && <InfoWindow onClose={onClosePopup}
																					   text={<StopMarkerPopup id={key}
																											  stop={stop}/>}/>}/>;
			})
		);
	} else if( props.page === Page.S2 ) {
		markers = markers.concat(
			props.visibleGyms.map(gym => {
				const key = 'gymdot-' + gym.gym_id;
				return <DotMarker key={key} name={gym.name} lat={gym.latitude} lng={gym.longitude} color={'#ff0000'} onClick={() => showPopup(key)}
						   infoWindow={infoWindowMarker === key && <InfoWindow onClose={onClosePopup} text={<DotMarkerPopup id={key} name={gym.name} type={S2MarkerType.GYM} portal={gym}/>}/>}
				/>;
			}),
			props.visibleStops.map(stop => {
				const key = 'stopdot-' + stop.latitude + stop.longitude;
				return <DotMarker key={key} name={'' + stop.name} lat={stop.latitude} lng={stop.longitude} color={'#0000ff'} onClick={() => showPopup(key)}
						   infoWindow={infoWindowMarker === key && <InfoWindow onClose={onClosePopup} text={<DotMarkerPopup id={key} name={stop.name} type={S2MarkerType.STOP} portal={stop}/>}/>}
				/>;
			}),
			props.visiblePortals.map(portal => {
				const key = 'portaldot-' + portal.latitude + portal.longitude;
				return <DotMarker key={key} name={'' + portal.name} lat={portal.latitude} lng={portal.longitude} color={'#666666'} onClick={() => showPopup(key)}
						   infoWindow={infoWindowMarker === key && <InfoWindow onClose={onClosePopup} text={<DotMarkerPopup id={key} name={portal.name} type={S2MarkerType.PORTAL} portal={portal}/>}/>}

				/>;
			}),
			props.pendingSubmissions.filter(p => p.title).map(portal => {
				const key = 'pendingdot-' + portal.latitude + portal.longitude;
				return <DotMarker key={key} name={'' + portal.title} lat={portal.latitude} lng={portal.longitude} color={'#00ff00'} onClick={() => showPopup(key)}
								  infoWindow={infoWindowMarker === key && <InfoWindow onClose={onClosePopup} text={<DotMarkerPopup id={key} name={portal.title} type={S2MarkerType.PENDING} portal={portal}/>}/>}
				/>;
			}),
			Object.keys(props.level14Centers).map(key => <Level14CellCenter key={key} lat={props.level14Centers[key].lat} lng={props.level14Centers[key].lng} keyName={key} />)
		);
	} else if( props.page === Page.NESTS && props.nestPolygons ) {
		markers = markers.concat(
			Object.values(props.nestPolygons).map(nest => {
				const key = 'nest-' + nest.nest.nest_id;
				return <NestMarker key={key} lat={nest.nest.nest_latitude} lng={nest.nest.nest_longitude} nest={nest.nest} onClick={() => showPopup(key)}
								   infoWindow={infoWindowMarker === key && <InfoWindow onClose={onClosePopup} text={<NestMarkerPopup id={key} nest={nest.nest} />} />} />;
			})
		)
	}

	return <Map>{markers}</Map>;
};
const mapStateToProps = (state) => {
	return {
		page: state.core.page,
		nestPolygons: state.core.nestPolygons,
		visibleGyms: selectVisibleGyms(state),
		visibleRaids: selectVisibleRaids(state),
		visiblePokemon: selectVisiblePokemon(state),
		visibleStops: selectVisibleStops(state),
		visiblePortals: selectVisiblePortals(state),
		level14Centers: state.map.level14Centers,
		pendingSubmissions: selectVisiblePendings(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(MapContainer);